import React, { useContext, useEffect } from "react";
import { Form as FormAntd, message } from "antd";
import { Layer } from "../../../../component/layer/layer";
import { InventoryGoodsFormBasic } from "./batchcoupon_form_basic";
import { Button } from "../../../../component/button";
import { BatchCouponFormStore, BatchCouponFormStoreProvider } from "../../store/batchCoupon/form_store";
import { batchcouponformAction } from "../../action/batchcoupon/form_action";
import { debug } from "console";
import { useBoolean } from "ahooks";

interface IForm {
    children?: any;
    action: any;
    close: (hasUpdate?: boolean) => void;
    couponID?: string;
    id: string;
    method?: string;
    audit: boolean;
    item;
}
export function Form({ close, method, couponID, item, audit, id }: IForm) {
    const [form] = FormAntd.useForm();

    const { state, dispatch } = useContext(BatchCouponFormStore);
    const [loading, loadFunc] = useBoolean(false)
    const action = batchcouponformAction;

    useEffect(() => {

        action.init({ state: state, dispatch, couponID, form, method, id });

        return () => {

        }
    }, []);

    const title = () => {
        if ("Create" === method) {
            return "新增精准发券";
        }
        else if ("Edit" === method) {
            return "编辑精准发券";
        }
        else {
            return "查看精准发券";
        }
    }

    return (
        <FormAntd form={form}>
            <Layer layerWith={3} >
                <Layer.Title  onClick={() => close()}>{title()}</Layer.Title>
                <Layer.Body>
                    <InventoryGoodsFormBasic disabled={!("Create" == method || "Edit" == method)} title={title()} updateFormField={(field, value = '') => {
                        form.setFieldsValue({
                            [field]: value,
                        });
                        form.validateFields([field]);
                    }} />
                </Layer.Body>
                <Layer.Foot borderStyle={title()=='查看精准发券'?{border:'none'}:{}}>

                {title()!='查看精准发券'&&
                        ("Create" == method || "Edit" == method) && audit && (
                           <> <Button type="primary" color="Red" onClick={async () => {
                                const s = await form.validateFields();
                                if(loading){
                                    message.loading('正在提交数据')
                                    return false
                                }
                                let r = false;
                                if ("Create" == method) {
                                    loadFunc.setTrue()
                                    r = await action.addSubmit({ state, status: 1 });
                                    loadFunc.setFalse()
                                } else {
                                    // r = await action.updSubmit({ state, status: 1 }, subId);
                                }
                                if (r) {
                                    action.clearTableList({ dispatch });

                                    close(true);
                                }
                            }}>
                                保存
                            </Button>
                             <Button type="primary" color="Yellow" style={{ marginLeft: "1.25rem" }} onClick={async () => {
                                action.clearTableList({ dispatch });
                                // action.reset({dispatch})
                                close(true);
                            }}>
                                返回
                            </Button>
                            </>
                        )
                    }
                   

                   
                </Layer.Foot>

            </Layer>
        </FormAntd>
    )
}